import { AbstractControl, FormArray, FormControl, ValidatorFn } from "@angular/forms";
import { VisibilityContext } from "../service/visibility-context";

export function viaFunctionValidator(schema: any, formModelService: any): ValidatorFn {
	return (control: AbstractControl) => {
		if (
			schema === undefined ||
			control.root instanceof FormControl
		) {
			return null;
		}

		const message = schema.Name ? `${schema.Name} is required` : '';
		let isInvalid = false;
		if (schema.required !== undefined && schema.required) {
			isInvalid =
				control instanceof FormArray
					? (control as FormArray).controls.length === 0
					: control.value === null || control.value.toString().trim() === '';
		} else if (schema.isRequired !== undefined) {
			let evaluation = false;

			if (typeof schema.isRequired === 'string') {
				evaluation = eval(`(${schema.isRequired})`)(
					control,
					new VisibilityContext(control, formModelService)
				);
			} else {
				evaluation = schema.isRequired(
					control,
					new VisibilityContext(control, formModelService)
				);
			}

			isInvalid = evaluation as boolean;
		}

		return isInvalid ? {required: message} : null;
	};
}
